<template>
  <div>
    
    <Loader :visible="isLoading" :text="loadingText" />

    <ConfirmationModal :show="confirmDeleteRow" @close="confirmDeleteRow = false">
        <template #title>Conferma Eliminazione Riga su Pacchetto Ore</template>

        <template #content>
            Sei sicuro di voler eliminare <strong>{{ rowDeletion.Description }}</strong> su {{ pkgOpen.ContractCod }} di {{ pkgOpen.CompanyName }} in data {{ rowDeletion.created_at.toLocaleString() }}?
        </template>

        <template #footer>
            <button 
                @click="confirmDeleteRow = false;" 
                class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 mr-2"
            >
                Annulla
            </button>
            <button 
                @click="rowDeletion.toDelete = true; confirmDeleteRow = false; forceResizeDetailsModal();" 
                class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
                Conferma
            </button>
        </template>
    </ConfirmationModal>

    <ConfirmationModal :show="confirmDeactivatePackage" @close="confirmDeactivatePackage = false">
        <template #title>Conferma Disattivazione Pacchetto Ore</template>

        <template #content>
            Sei sicuro di voler disattivare {{ deactivateRow.ItemId }} di {{ deactivateRow.ContractCod }} del cliente {{ deactivateRow.CompanyName }}?
            <br>
            <strong class="text-red-700">Attenzione: Questa operazione non è reversibile (ricorda di disattivare anche la riga dai contratti).</strong>
        </template>

        <template #footer>
            <button 
                @click="confirmDeactivatePackage = false;" 
                class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 mr-2"
            >
                Annulla
            </button>
            <button 
                @click="disablePackage()" 
                class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
                Conferma
            </button>
        </template>
    </ConfirmationModal>
    
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>

    <div class="p-6 pb-0 flex items-center">
      <!--<button @click="openPkgModal" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md">Nuovo pacchetto</button>--><!-- Non bisogna crearlo da qui perché poi manca il contratto principale per il rinnovo -->
      
      <select v-model="selectedItemId" @change="performSearch()" class="p93__input_general px-4 py-2 ml-4 w-64 truncate">
        <option value="">Tutti i pacchetti</option>
        <option value="SAP93HWSPS">[SAP93HWSPS] SERVIZIO ASSISTENZA HW SPS</option>
        <option value="SAP93SWFPS">[SAP93SWFPS] SERVIZIO ASSISTENZA SW FPS</option>
        <option value="SAP93PROSW">[SAP93PROSW] ATTIVITA' PER INTERVENTO SU PROCEDURE SOFTWARE</option>
        <option value="SAP93REPORT">[SAP93REPORT] SERVIZIO GESTIONE REPORTISTICA</option>
        <option value="SAP93SWFPS_FF">[SAP93SWFPS_FF] SERVIZIO DOCENZA SW FPS</option>
        <option value="SAP93SWPEPS">[SAP93SWPEPS] SERVIZIO FORMAZIONE A PACCHETTO ORE</option>
		    <option value="SAP93ALLIN">[SAP93ALLIN] SERVIZIO ASSISTENZA HW/SW ALLIN</option>
        <option value="SAP93HWINT">[SAP93HWINT] ATTIVITA' DI INTERVENTO TECNICO/SISTEMISTICO</option>
        <option value="SAP93SWWMS">[SAP93SWWMS] SERVIZIO FORMAZIONE WMS & WEB PORTAL TICKET PACCHETTO ORE</option>
      </select>
      <select v-model="modelFilter" @change="performSearch()" class="p93__input_general px-4 py-2 ml-4 w-64 truncate">
        <option value="">Tutti i modelli</option>
        <option value="TICKET">[TICKET] TICKET CONSUNTIVO</option>
        <option value="FPS">[FPS] FULL PACKAGE SERVICE</option>
        <option value="PEOSMAF">[PEOSMAF] PEOPLE SMART</option>
      </select>
      <select v-model="agentFilter" @change="performSearch()" class="p93__input_general px-4 py-2 ml-4 w-52 truncate">
        <option value="">Tutti gli agenti</option>
        <option v-for="sp in salesPeople" :key="sp.id" :value="sp.id">{{ sp.name }}</option>
      </select>
      <input v-model="search" type="text" placeholder="Cerca per nome cliente o codice contratto" class="p93__input_general px-4 py-2 ml-4" @keyup.enter="performSearch()" style="width:340px"/>
      <button @click="exportNegativiExcel()" class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 ml-4 rounded-md whitespace-nowrap">
        <i class="fa fa-file-excel mr-1"></i> Esporta negativi
      </button>
    </div>
    <div class="p-6 pb-0">
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <SortableTableHeader 
              title="Cliente" 
              field="CompanyName" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Agente" 
              field="AgentName" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Modello" 
              field="ContractModel" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Codice Pacchetto" 
              field="ItemDescription" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Contratto" 
              field="ContractCod" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <SortableTableHeader 
              title="Ore contratto" 
              field="AmountTotal" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <th class="py-2 px-4 border-b text-center">Ore totali</th>
            <th class="py-2 px-4 border-b text-center">Ore utilizzate</th>
            <SortableTableHeader 
              title="Ore residue" 
              field="Balance" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <SortableTableHeader 
              title="% ore consumate" 
              field="PercentageUsed" 
              :currentSortField="sortField" 
              :sortDirection="sortDirection" 
              :isDefault="true"
              @sort="sort" 
            />
            <th class="py-2 px-4 border-b text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pkg in packages.data" :key="pkg.id">
            <td class="py-2 px-4 border-b text-left">{{ pkg.CompanyName }}</td>
            <td class="py-2 px-4 border-b text-left">{{ pkg.AgentName }}</td>
            <td class="py-2 px-4 border-b text-left">{{ pkg.ContractModel }}</td>
            <td class="py-2 px-4 border-b text-left">{{ pkg.ItemDescription }}</td>
            <td class="py-2 px-4 border-b text-left">{{ pkg.ContractCod }}</td>
            <td class="py-2 px-4 border-b text-left">{{ toHours(pkg.AmountTotal).toLocaleString('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ toHours(pkg.MovimentiPositivi).toLocaleString('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ toHours(pkg.MovimentiNegativi).toLocaleString('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ toHours(pkg.Balance).toLocaleString('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ (pkg.PercentageUsed).replace('.', ',').toLocaleString('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}%</td>
            <td class="py-2 px-4 border-b text-center relative">
              <div class="relative inline-block text-left">
                <button @click="toggleActionMenu(pkg.id)" type="button" class="bg-gray-200 text-gray-700 rounded-full p-1 hover:bg-gray-300 focus:outline-none">
                  <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                  </svg>
                </button>
                <div v-if="openActionMenu === pkg.id" 
                     class="origin-top-right absolute right-0 top-0 mr-8 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10"
                     @mouseleave="closeActionMenu">
                  <div class="py-1" role="menu" aria-orientation="vertical">
                    <button @click="openRenewPackageModal(pkg)" 
                            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" 
                            role="menuitem">
                      Rinnova
                    </button>
                    <button @click="openDetailsModal(pkg)" 
                            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" 
                            role="menuitem">
                      Dettagli
                    </button>
                    <button @click="openRenewPdfHistory(pkg)" 
                            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" 
                            role="menuitem">
                      Storico rinnovi (PDF)
                    </button>
                    <button @click="downloadCurrentReport(pkg)" 
                            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" 
                            role="menuitem">
                      Scarica report situazione attuale (PDF)
                    </button>
                    <button @click="deactivateRow = pkg; confirmDeactivatePackage = true;" 
                            class="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-100 hover:text-red-900" 
                            role="menuitem">
                      Disattiva pacchetto
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="6"><Pagination :links="packages.links" :only="['packages']" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Modale per aggiungere pacchetto -->
  <div v-if="showPkgModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closePkgModal">
    <div ref="pkgModal" class="bg-white p-6 rounded-md w-full max-w-md relative" @mousedown.stop>
      <div @mousedown="startDrag($event, $refs.pkgModal)" class="cursor-move mb-4 -mt-2 -mx-2 p-2">
        <h2 class="text-xl select-none">Aggiunta pacchetto</h2>
      </div>
      <form @submit.prevent="addPkg()">
        <div class="mb-4">
          <label class="block text-gray-700">Cliente</label>
          <v-select :options="foundClients" :filterable="false" v-model="pkgForm.Customer" label="name"
            @search="searchClients" @option:selected="onClientSelect" required>
            <template #no-options="{ search, searching }">
              <div v-if="searching">🔍 Ricerca in corso...</div>
              <div v-else-if="!search">Inizia a digitare per cercare un cliente...</div>
            </template>
          </v-select>
          <div v-if="pkgForm.Customer" class="py-4 text-red-800">{{ pkgForm.errors.Customer }}</div>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700">Codice contratto</label>
          <input v-model="pkgForm.ContractCod" class="p93__input">
          <div v-if="pkgForm.errors.ContractCod" class="text-red-500 text-sm">{{ pkgForm.errors.ContractCod }}</div>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700">Codice pacchetto</label>
          <select v-model="pkgForm.ItemId" class="p93__input" required autocomplete="nope">
            <option value="SAP93HWSPS">[SAP93HWSPS] SERVIZIO ASSISTENZA HW SPS (SISTEMISTICA) CON TICKET A PACCHETTO ORE</option>
            <option value="SAP93SWFPS">[SAP93SWFPS] SERVIZIO ASSISTENZA SW FPS TICKET PACCHETTO ORE</option>
            <option value="SAP93PROSW">[SAP93PROSW] ATTIVITA' PER INTERVENTO SU PROCEDURE SOFTWARE TICKET N° xx</option>
            <option value="SAP93REPORT">[SAP93REPORT] SERVIZIO GESTIONE REPORTISTICA TICKET N° xx</option>
            <option value="SAP93SWFPS_FF">[SAP93SWFPS_FF] SERVIZIO DOCENZA SW FPS TICKET PACCHETTO ORE FORMAZIONE FONDO INTERPROFESSIONALE</option>
            <option value="SAP93SWPEPS">[SAP93SWPEPS] SERVIZIO FORMAZIONE A PACCHETTO ORE PEOPLE SMART</option>
            <option value="SAP93ALLIN">[SAP93ALLIN] SERVIZIO ASSISTENZA HW/SW ALLIN</option>
            <option value="SAP93SWWMS">[SAP93SWWMS] SERVIZIO FORMAZIONE WMS & WEB PORTAL TICKET PACCHETTO ORE</option>
          </select>
          <div v-if="pkgForm.errors.ItemId" class="text-red-500 text-sm">{{ pkgForm.errors.ItemId }}</div>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700">Ore</label>
          <input v-model="pkgForm.Amount" class="p93__input" required>
          <div v-if="pkgForm.errors.Amount" class="text-red-500 text-sm">{{ pkgForm.errors.Amount }}</div>   
        </div>
        <div v-if="pkgForm.errors.general" class="text-red-500 text-sm">{{ pkgForm.errors.general }}</div>
        <div class="flex justify-end">   
          <button type="button" @click="closePkgModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ 'Procedi' }}</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modale per rinnovo pacchetto -->
  <div v-if="showRenewModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeRenewModal">
    <div ref="renewModal" class="bg-white p-6 rounded-md w-full max-w-2xl relative" @mousedown.stop>
      <div @mousedown="startDrag($event, $refs.renewModal)" class="cursor-move mb-4 -mt-2 -mx-2 p-2">
        <h2 class="text-xl select-none">Rinnovo pacchetto per {{ pkgOpen.ContractCod }}</h2>
      </div>
      <form @submit.prevent="renewPackage()" @keydown.enter.prevent.stop>
        <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-4">
          <div>
            <label class="block text-gray-700">Cliente</label>
            <input type="text" v-model="renewForm.CustomerName" class="p93__input w-full" readonly />
          </div>
          <div>
            <label class="block text-gray-700">Pacchetto</label>
            <input type="text" v-model="renewForm.PackageName" class="p93__input w-full" readonly />
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="mb-4">
            <label class="block text-gray-700">Ore rinnovo</label>
            <input type="number" step="0.001" v-model="renewForm.Qty" class="p93__input w-full" required />
            <div v-if="renewForm.errors.Qty" class="text-red-500 text-sm">{{ pkgForm.errors.Qty }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Ore conguaglio</label>
            <input type="number" step="0.001" v-model="renewForm.Adjustment" class="p93__input w-full" required readonly />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Saldo dopo il rinnovo</label>
            <input type="number" :value="(parseFloat(renewForm.Qty || 0) + parseFloat(renewForm.Adjustment || 0)).toFixed(3)" class="p93__input w-full" required readonly />
          </div>
        </div>
        <div class="grid grid-cols1 md:grid-cols-3 gap-6 mb-4">
           <div class="mb-4">
            <label class="block text-gray-700">% Istat</label>
            <input type="number" step="0.001" v-model="renewForm.Istat" class="p93__input w-full" required />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Costo unitario</label>
            <input type="number" step="0.001" v-model="renewForm.UnitPrice" class="p93__input w-full" required />
          </div>
          <div class="mb-4">
              <label class="block text-gray-700">Data</label>
              <VueDatePicker v-model="renewForm.Date" locale="it" format="dd/MM/yyyy" text-input
                            :enable-time-picker="false" :position="'bottom'" auto-apply
                            class="w-full border border-neutral-300 rounded-md shadow-md" @input="pageDateInput"/>
          </div>
        </div>
        <input type="hidden" v-model="renewForm.CustomerId" />
        <input type="hidden" v-model="renewForm.PackageId" />
        <input type="hidden" v-model="renewForm.ContractCod" />
        <div class="flex justify-end mt-4">
          <button type="button" @click="closeRenewModal" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
            <button type="submit" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md" :disabled="isProcessingRenew">
            <span v-if="isProcessingRenew">Elaborazione...</span>
            <span v-else>Procedi</span>
            </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modale per dettagli pacchetto -->
  <div v-if="showDetailsModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeDetailsModal">
    <div ref="detailsModal" id="detailsModal" class="bg-white pl-6 pr-6 pt-6 pb-6 rounded-md w-full max-w-6xl relative" @mousedown.stop>
      <div @mousedown="startDrag($event, $refs.detailsModal)" class="cursor-move mb-4 sticky top-0 bg-white z-10 grid grid-cols-2">
        <div class="text-xl select-none">Dettagli pacchetto {{ pkgOpen.ContractCod }}</div>
        <div class="text-right">
          <button @click="copyTableToClipboard()" 
            class="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md mr-2">
            <i class="fa fa-clone mr-1"></i> Copia tabella negli appunti
          </button>
          <button @click="openAddMovementModal()" 
            class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
            <i class="fa fa-plus mr-1"></i> Aggiungi movimento
          </button>
        </div>
      </div>
      <div class="max-h-[70vh] overflow-y-auto" id="detailsTableContainer">
        <table class="min-w-full bg-white rounded-md shadow-lg">
          <thead>
            <tr>
              <th class="py-2 px-4 border-b text-left">Descrizione</th>
              <th class="py-2 px-4 border-b text-left">Minuti</th>
              <th class="py-2 px-4 border-b text-left" style="width: 270px;">Data</th>
              <th class="py-2 px-4 border-b text-left"># Ticket CRM</th>
              <th class="py-2 px-4 border-b text-left">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="movement in packageMovements.data.filter(x => !x.toDelete).sort(function(a, b){return b.created_at - a.created_at})" :key="movement.id">
              <td class="py-2 px-4 border-b text-left">
                <input v-model="movement.Description" type="text" class="p93__input w-full" />
              </td>
              <td class="py-2 px-4 border-b text-left">
                <input 
                    v-model.number="movement.Amount" 
                    type="number"
                    step="0.01"
                    :class="'p93__input w-32' + (movement.Amount < 0 ? ' text-red-600' : (movement.Amount > 0 ? ' text-green-600' : ''))"
                    placeholder="0.00"
                />
              </td>
              <!--<td class="py-2 px-4 border-b text-left" 
                  :class="{ 
                    'text-red-600': parseFloat(movement.Amount) < 0, 
                    'text-green-600': parseFloat(movement.Amount) > 0 
                  }">
                {{ movement.Amount }}
              </td>-->
              <td class="py-2 px-4 border-b text-left">
                <VueDatePicker v-model="movement.created_at" locale="it" format="dd/MM/yyyy HH:mm:ss" auto-apply
                              teleport enable-seconds time-picker-inline text-input
                              class="w-full border border-neutral-300 rounded-md shadow-md" placeholder="dd/MM/yyyy HH:mm:ss"/>
              </td>
              <td class="py-2 px-4 border-b text-left">
                <input 
                    v-model.number="movement.ExternalId" 
                    type="text"
                    class="p93__input w-32"
                />
              </td>
              <th class="py-2 px-4 border-b text-left">
                <button type="button" @click="rowDeletion = movement; confirmDeleteRow = true" class="text-red-500 hover:text-red-700">
                  <i class="fa fa-trash"></i>
                </button>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-end mt-4">
        <button class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md mr-2" @click="saveDetails">
        <i class="fa fa-save"></i> Salva Modifiche
        </button>
        <button type="button" @click="closeDetailsModal" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">Chiudi</button>
      </div>
    </div>
  </div>

  

    <!-- Modale per aggiungere movimento -->
  <div v-if="showMovementModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeMovementModal">
    <div ref="movementModal" class="bg-white p-6 rounded-md w-full max-w-md relative" @mousedown.stop>
      <div @mousedown="startDrag($event, $refs.movementModal)" class="cursor-move mb-4 -mt-2 -mx-2 p-2">
        <h2 class="text-xl select-none">Aggiunta movimento su {{ pkgOpen.ContractCod }}</h2>
      </div>
      <div>
        <div class="mb-4">
          <label class="block text-gray-700">Descrizione</label>
          <input v-model="movementForm.Description" type="text" class="p93__input">
        </div>
        <div class="mb-4">
          <label class="block text-gray-700">Data</label>
          <VueDatePicker v-model="movementForm.Date" locale="it" format="dd/MM/yyyy HH:mm:ss" text-input
                            :position="'bottom'" enable-seconds time-picker-inline auto-apply
                            class="w-full border border-neutral-300 rounded-md shadow-md" placeholder="dd/MM/yyyy HH:mm:ss"/>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700">Minuti</label>
          <input v-model="movementForm.Minutes" type="text" class="p93__input" required>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700"># Ticket CRM</label>
          <input v-model="movementForm.ExternalId" type="text" class="p93__input">
        </div>
        <div class="flex justify-end">
          <button type="button" @click="closeMovementModal" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button type="button" @click="addMovement" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">Procedi</button>
        </div>
      </div>
    </div>
  </div>

   <!-- Modale per elenco pdf -->
  <div v-if="showHistoryModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeHistoryModal">
    <div ref="historyModal" class="bg-white p-6 rounded-md w-full max-w-4xl max-h-[80vh] overflow-y-auto relative" @mousedown.stop>
      <div @mousedown="startDrag($event, $refs.historyModal)" class="cursor-move mb-4 -mt-2 -mx-2 p-2 sticky top-0 bg-white z-10">
        <h2 class="text-xl select-none">Dettagli rinnovi di {{ pkgOpen.ContractCod }}</h2>
      </div>
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <th class="py-2 px-4 border-b text-left">Data</th>
            <th class="py-2 px-4 border-b text-left">File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in files" :key="file.name">
            <td class="py-2 px-4 border-b text-left">{{ file.last_modified }}</td>
            <td class="py-2 px-4 border-b text-left">
              <a :href="getDownloadUrl(file.directory, file.name)" 
                 class="text-blue-500 hover:text-blue-700 underline"
                 target="_blank">
                {{ file.name }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex justify-end mt-4">
        <button type="button" @click="closeHistoryModal" class="bg-gray-500 hover:bg-gray-500 text-white px-4 py-2 rounded-md">Chiudi</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import SortableTableHeader from '@/Components/SortableTableHeader.vue';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import Loader from '@/Components/Loader.vue';
import axios from 'axios';

export default {
  props: ['packages', 'salesPeople', 'errors'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    SortableTableHeader,
    ConfirmationModal,
    Loader
  },
  data() {
    return {
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: 'Contratti', href: route('modules.home', 'contratti') },
        { name: 'Report Pacchetti Ore', href: route('modules.contratti.report-pacchetti-ore') }
      ],
      sortField: new URLSearchParams(window.location.search).get('sort'),
      sortDirection: new URLSearchParams(window.location.search).get('direction'),
      pkgForm: useForm({
        Customer: '',
        CustomerId: '',
        ContractCod: '',
        ItemId: '',
        Amount: 0
      }),
      movementForm: {
        PackageId: '',
        Minutes: '',
        Description: '',
        Date: '',
        ExternalId: ''
      },
      renewForm: useForm({
        CustomerId: '',
        PackageId: '',
        ItemId: '',
        CustomerName: '',
        PackageName: '',
        Qty: 0,
        ContractCod: '',
        Adjustment: 0,
        AdjustmentMinutes: 0,
        Istat: 0,
        UnitPrice: 0,
        Date: new Date().toISOString().split('T')[0] // Default to today's date
      }),
      showMovementModal: false,
      showPkgModal: false,
      showRenewModal: false,
      showDetailsModal: false,
      showHistoryModal: false,
      foundClients: [],
      openActionMenu: null,
      selectedItemId: '', // Holds the selected ItemId for filtering
      selectedCustomer: null, // Holds the selected customer for filtering
      foundCustomers: [], // Holds the list of customers found during search
      search: new URLSearchParams(window.location.search).get('search'),
      packageMovements: {
        data: [],
        links: []
      },
      files: [], // Files for the history modal
      isProcessingRenew: false,
      confirmDeleteRow: false,
      rowDeletion: null,
      pkgOpen: null,
      deactivateRow: null,
      confirmDeactivatePackage: false,
      modelFilter: '',
      agentFilter: new URLSearchParams(window.location.search).get('agentFilter') || ''
    };
  },
  methods: {
    sort(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }
      this.performSearch();
    },
    performSearch() {
      const params = { 
        search: this.search,
        sort: this.sortField || 'CompanyName',
        direction: this.sortDirection || 'asc',
        selectedItemId: this.selectedItemId,
        modelFilter: this.modelFilter,
        agentFilter: this.agentFilter
      };
      router.get(route('modules.contratti.report-pacchetti-ore'), params, {
        preserveState: true,
        preserveScroll: true,
        replace: true
      });
    },
    addPkg() {
      this.pkgForm.post(route('modules.contratti.aggiungi-pacchetto-ore'), {
        preserveUrl: true,
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => this.closePkgModal()
      });
    },
    forceResizeDetailsModal()
    {
      this.$nextTick(() => {
        //Bug del css?
        document.getElementById('detailsModal').style.height = (document.getElementById('detailsTableContainer').clientHeight + 160) + "px";
      });
    },
    addMovement() {
      /*
      const currentParams = new URLSearchParams(window.location.search);
      const queryParams = Object.fromEntries(currentParams.entries());
      this.movementForm.post(route('modules.contratti.pacchetti-ore.aggiungi-movimento', queryParams), {
        preserveUrl: true,
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => this.closeMovementModal()
      });*/
      this.packageMovements.data.push({
        id: -1,
        PackageId: this.pkgOpen.id,
        Amount: this.movementForm.Minutes,
        Description: this.movementForm.Description,
        created_at: this.movementForm.Date,
        updated_at: this.movementForm.Date,
        ExternalId: this.movementForm.ExternalId
      });
      this.closeMovementModal();
      this.forceResizeDetailsModal();
    },
    renewPackage() {
      this.isProcessingRenew = true;
      const currentParams = new URLSearchParams(window.location.search);
      const queryParams = Object.fromEntries(currentParams.entries());
      this.renewForm.post(route('modules.contratti.pacchetti-ore.rinnova', queryParams), {
        preserveUrl: true,
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => this.closeRenewModal()
      });
    },
    openPkgModal() {
      this.pkgForm.Customer = '';
      this.pkgForm.ContractCod = '';
      this.pkgForm.ItemId = '';
      this.pkgForm.Qty = '';
      this.pkgForm.errors = {}; // Clear any validation errors
      this.showPkgModal = true; // Show the modal
    },
    closePkgModal() {
      this.showPkgModal = false;
      this.resetModalPosition();
    },
    closeMovementModal() {
      this.showMovementModal = false;
      this.resetModalPosition();
    },
    closeRenewModal() {
      this.showRenewModal = false;
      this.isProcessingRenew = false;
      this.resetModalPosition();
    },
    closeDetailsModal() {
      this.showDetailsModal = false;
      this.resetModalPosition();
    },
    closeHistoryModal() {
      this.showHistoryModal = false;
      this.resetModalPosition();
    },
    openAddMovementModal() {
      this.movementForm.Amount = '';
      this.movementForm.Description = '';
      this.movementForm.Date = '';
      this.movementForm.Minutes = '';
      this.movementForm.ExternalId = '';
      
      this.showMovementModal = true;
    },
    searchClients(search, loading) {
      if (search.length >= 2) {
        loading(true);
        clearTimeout(this.searchContactsTimeout);
        this.searchContactsTimeout = setTimeout(() => {
          axios
            .get(route('modules.contratti.ricerca-clienti', search))
            .then((response) => {
              this.foundClients = response.data;
              loading(false);
            });
        }, 300);
      }
    },
    searchCustomers(search, loading) {
      if (search.length >= 2) {
        loading(true);
        clearTimeout(this.searchCustomersTimeout);
        this.searchCustomersTimeout = setTimeout(() => {
          axios
            .get(route('modules.contratti.ricerca-clienti', search))
            .then((response) => {
              this.foundCustomers = response.data;
              loading(false);
            });
        }, 300);
      }
    },
    onClientSelect() {
      this.pkgForm.CustomerId = this.pkgForm.Customer.id;
    },
    toggleActionMenu(PackageId) {
      this.openActionMenu = this.openActionMenu === PackageId ? null : PackageId;
    },
    closeActionMenu() {
      this.openActionMenu = null;
    },
    openRenewPackageModal(pkg) {
      const adjustment =  parseInt(pkg.Balance);
      this.getItemPrice(pkg.CustomerId, pkg.ItemId, pkg.ContractCod);
      this.renewForm.CustomerId = pkg.CustomerId;
      this.renewForm.PackageId = pkg.id;
      this.renewForm.ItemId = pkg.ItemId;
      this.renewForm.CustomerName = pkg.CompanyName;
      this.renewForm.PackageName = pkg.ItemDescription;
      this.renewForm.Qty = Math.abs((adjustment / 60).toFixed(3));
      this.renewForm.ContractCod = pkg.ContractCod;
      this.renewForm.Adjustment = (adjustment / 60).toFixed(3);
      this.renewForm.AdjustmentMinutes = adjustment;
      this.renewForm.Istat = 0;
      this.renewForm.Date = new Date().toISOString().split('T')[0]; // Default to today's date
      this.showRenewModal = true;
      this.pkgOpen = pkg;
    },
    getItemPrice(CustomerId, ItemId, ContractCod) {
      axios
        .post(route('modules.contratti.riga.cerca', { item: ItemId, customerId: CustomerId, contractCod: ContractCod }))
        .then((response) => {
          this.renewForm.UnitPrice = response.data?.UnitValue;
        });
    },
    openDetailsModal(pkg, page = 1) {
      axios
        .get(route('modules.contratti.pacchetti-ore.movimenti', { packageId: pkg.id, page: page }))
        .then((response) => {
          response.data.forEach(movement => {
            movement.created_at = new Date(movement.created_at);
          });
          this.packageMovements = response;
          this.showDetailsModal = true;
          this.pkgOpen = pkg;
        });
    },
    openRenewPdfHistory(pkg, page = 1) {
      const directory = pkg.CustomerId + '-' + pkg.ItemId;
      console.log(directory);
      axios
        .get(route('modules.contratti.pacchetti-ore.storicoRinnoviPdf', { directory: directory }))
        .then((response) => {
          this.files = response.data.files;
          this.showHistoryModal = true;
          this.pkgOpen = pkg;
        });
    },
    downloadCurrentReport(pkg) {
      window.location.href = route('modules.contratti.pacchetti-ore.downloadReport', { packageId: pkg.id });
    },
    getDownloadUrl(directory, filename) {
      return route('modules.contratti.pacchetti-ore.storicoRinnoviPdf.download', { 
        directory: directory, 
        filename: filename 
      });
    },
    async saveDetails(){
      var copy = JSON.parse(JSON.stringify(this.packageMovements.data));
      await this.withLoaderSafe(
          async () => {
              const response = await axios
              .post(route('modules.contratti.pacchetti-ore.salva-modifiche'), 
                //Ignora le righe con id -1 (nuove) che poi sono state cancellate
                { rows: this.packageMovements.data.filter(x => x.id != -1 || !x.toDelete) }
              )
              .then((response) => {
                if (response.data.success){
                  this.closeDetailsModal();
                  router.reload();
                }
                else{
                  console.log(response);
                  alert('Si è verificato un errore durante il salvataggio delle modifiche.');
                }
              });
              return response;
          },
          `Salvataggio in corso ...`,
          (error) => {
              console.log(error);
              alert('Si è verificato un errore durante il salvataggio delle modifiche.');
          }
      );
    },
    async disablePackage(){
      const response = await axios
      .post(route('modules.contratti.pacchetti-ore.disattiva-pacchetto'), 
        { packageId: this.deactivateRow.id }
      )
      .then((response) => {
        if (response.data.success){
          this.confirmDeactivatePackage = false;
          router.reload();
        }
        else{
          console.log(response);
          alert('Si è verificato un errore durante la disattivazione del pacchetto.');
        }
      });
    },
    exportNegativiExcel() {
      const params = new URLSearchParams({
        search: this.search || '',
        selectedItemId: this.selectedItemId || '',
        modelFilter: this.modelFilter || '',
        agentFilter: this.agentFilter || ''
      });
      window.location.href = route('modules.contratti.pacchetti-ore.export-negativi') + '?' + params.toString();
    },
    copyTableToClipboard(){
      var contentstring = "";
      this.packageMovements.data.filter(x => !x.toDelete).sort(function(a, b){return b.created_at - a.created_at}).forEach(x => {
        contentstring += x.Description + "\t" + x.Amount.replace('.', ',') + "\t" + x.created_at.toLocaleString() + "\t" + x.ExternalId + "\r\n";
      })
      navigator.clipboard.writeText(contentstring);
    }
  }
};
</script>